import React, { useState } from "react";
import './HomePageGoogle.scss';
import emailjs from 'emailjs-com';
import { Helmet } from "react-helmet";
import LocationReviewsData from './LocationReviewsData'
// images
import carlock from '../../Images/carlock.png'
import reslock from '../../Images/reslock.png'
import comlock from '../../Images/comlock.png'
import bgnobgs from '../../Images/bgnobgs.png'
import { useLocation, useNavigate } from "react-router-dom";

export default function HomePageGoogle({ CitiePhone, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    // Contact Us

    return (
        <div className="HomePageGoogle" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>NoneStop 24/7 Locksmith | Expert Locksmith Service | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content=" | Expert Locksmith Service | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content=" | Expert Locksmith Service | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.NoneStop 24/7 Locksmithlocksmithsweep.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content=" provides top-quality locksmith cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your locksmith service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content=" provides top-quality locksmith cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your locksmith service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="" data-react-helmet="true" />
                <meta name="keywords" content=", locksmith Inspection, locksmith Inspection, Fireplace Inspection, Fireplace Cleaning, locksmith Cleaning, locksmith Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, locksmith Inspection, Fireplace Inspection, Fireplace Cleaning, locksmith Cleaning, locksmith Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, locksmith services, locksmith service, locksmith Inspection, Fireplace Inspection, Fireplace Cleaning, locksmith Cleaning, locksmith Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, locksmith Insulation, locksmith Installation, locksmith Liner Repair, locksmith Pointing, locksmith Rainp Installation, locksmith Repair, locksmith Crown Repair, locksmith Restoration, locksmith Flue Installation, locksmith Flue Repair, ​locksmith Construction, locksmith Vent Installation, locksmith Flashing, Flexible locksmith Liner Installation, locksmith Damper Repair, locksmithp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}

            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>The Locksmith Experts You've Trusted for Over 50 Years In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas - Fast, Same-Day Locksmith Services.</h2>
                    {/* <h2>locksmith Cleaning Near Me</h2> */}
                    <h3><img src={require(`../../Images/check.png`)} />Fast 15 Minute Arrival Times</h3>
                    <h3><img src={require(`../../Images/check.png`)} />Licensed | Bonded | Insured</h3>
                    <h3><img src={require(`../../Images/check.png`)} />Satisfaction Guaranteed</h3>
                    <a href={`tel:${CitiePhone}`}>Call Us Now!</a>
                    <a href={`tel:${CitiePhone}`}>Call {CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                </div>
                <div className="MainBannerRight">
                    <img src={bgnobgs} alt=" NoneStop 24/7 Locksmith | locksmith Repair NoneStop 24/7 Locksmith | locksmith Services NoneStop 24/7 Locksmith | locksmith Inspection NoneStop 24/7 Locksmith" />
                    <div className="MainBannerRightBubble1"></div>
                    <div className="MainBannerRightBubble2"></div>
                </div>
            </div>
            <div className="BookAnAppointmentMainComponentEmergery1" >
                <div className="BookAnAppointmentMainComponentEmergeryBox">
                    <div className="MainBannerLeftRated">
                        <p>Fast, Affordable {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"} Locksmith Service</p>

                        <h3>Rated 4.9 on Google</h3>
                        <span>
                            <h4>4.9</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                    {/* <a href={`tel:${CitiePhone}`}> Click To Call: {CitiePhone}</a> */}
                </div>
            </div>
            <div className="MainBanner2Top2" id="ourservices">
                <div className="MainBanner2TopBox">
                    <h1>OWE SPECIALIZE IN</h1>
                    <h2>LOCKSMITH SERVICES</h2>
                    <div className="MainBanner2TopBoxMenu">
                        <a className="MainBanner2TopBoxBox">
                            <img src={carlock} alt="locksmith Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <img src={require(`../../Images/car.png`)} />
                            </div>
                            <h3>Automotive Locksmith</h3>
                            <p><span></span>Car Lockout </p>
                            <p><span></span>Vehicle Key Making </p>
                            <p><span></span>Ignition Replacement </p>
                            <p><span></span>Duplicate Car Keys </p>
                            <p><span></span>Car Key Extraction </p>
                            <p><span></span>Replace Car Keys </p>
                            <p><span></span>And More </p>
                            <a href={`tel:${CitiePhone}`}>Call {CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>

                        </a>
                        <a className="MainBanner2TopBoxBox">
                            <img src={reslock} alt="locksmith Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <img src={require(`../../Images/home.png`)} />
                            </div>
                            <h3>Residential Locksmith</h3>
                            <p><span></span>House Lockout</p>
                            <p><span></span>Lock Rekey</p>
                            <p><span></span>Smart Locks</p>
                            <p><span></span>Lock Repairs</p>
                            <p><span></span>Lock Change</p>
                            <p><span></span>New Lock Installation</p>
                            <p><span></span>And More</p>
                            <a href={`tel:${CitiePhone}`}>Call {CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>

                        </a>
                        <a className="MainBanner2TopBoxBox">
                            <img src={comlock} alt="locksmith Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <img src={require(`../../Images/office.png`)} />
                            </div>
                            <h3>Commercial Locksmith</h3>
                            <p><span></span>Business / Office Lockout</p>
                            <p><span></span>Mail Box / Cabinet Change</p>
                            <p><span></span>New Lock Installation</p>
                            <p><span></span>Safe Lockout</p>
                            <p><span></span>Apartment Complexes & Hotels </p>
                            <p><span></span>Property Managers </p>
                            <p><span></span>And More </p>
                            <a href={`tel:${CitiePhone}`}>Call {CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>

                        </a>

                    </div>
                </div>
            </div>
            <div className="AirDuctReviews" id="reviews">
                <h1>TESTIMONIALS</h1>
                <h2>See What Our Customers Had To Say</h2>
                <div className="HomePageGoogleReviewsList">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="HomePageGoogleReviewsBox">
                            <h1>
                                <img src={require(`../../Images/Google.png`)} />
                            </h1>
                            <h3>{A.review}</h3>
                            <div className="HomePageGoogleReviewsBoxMore">
                                <img src={require(`../../Images/people.png`)} />
                                <span>
                                    <h2>{A.customer}</h2>
                                    <h4>
                                        <img src={require(`../../Images/star.png`)} />
                                        <img src={require(`../../Images/star.png`)} />
                                        <img src={require(`../../Images/star.png`)} />
                                        <img src={require(`../../Images/star.png`)} />
                                        <img src={require(`../../Images/star.png`)} />
                                    </h4>
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                <a href={`tel:${CitiePhone}`}>Tap To Call!</a>
                <a href={`tel:${CitiePhone}`}>Call {CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
            </div>
            <div className="HomePageGoogleWhy">
                <h1>100% SAFETY GUARANTEED</h1>
                <h2>Why Choose Us</h2>
                <div className="HomePageGoogleWhyMain">
                    <div className="HomePageGoogleWhyMainLeft">
                        <div className="HomePageGoogleWhyMainLeftBox">
                            <div className="HomePageGoogleWhyMainLeftImg">
                                <img src={require(`../../Images/check.png`)} />
                            </div>
                            <h3>Regain Access Anytime</h3>
                            <h4>Get quick, professional help to unlock doors when locked out of your home, car, or office 24/7.</h4>
                        </div>
                        <div className="HomePageGoogleWhyMainLeftBox">
                            <div className="HomePageGoogleWhyMainLeftImg">
                                <img src={require(`../../Images/check.png`)} />
                            </div>
                            <h3>Ensure Security</h3>
                            <h4>Upgrade safety with expert installation or repair of locks for doors, windows, safes, and more in homes or businesses.</h4>
                        </div>
                        <div className="HomePageGoogleWhyMainLeftBox">
                            <div className="HomePageGoogleWhyMainLeftImg">
                                <img src={require(`../../Images/check.png`)} />
                            </div>
                            <h3>Convenience</h3>
                            <h4>Have spare keys made or lost keys replaced promptly, ensuring continued access to your property without hassle.</h4>
                        </div>
                    </div>
                    <div className="HomePageGoogleWhyMainMiddle">
                        <img src={bgnobgs} />
                        <div className="HomePageGoogleWhyMainMiddleBox"></div>
                    </div>
                    <div className="HomePageGoogleWhyMainLeft">
                        <div className="HomePageGoogleWhyMainLeftBox">
                            <div className="HomePageGoogleWhyMainLeftImg">
                                <img src={require(`../../Images/check.png`)} />
                            </div>
                            <h3>Advanced Security</h3>
                            <h4>Upgrade to modern locks with keyless entry, controlled remotely for convenience, enhanced safety, and ease of access management.</h4>
                        </div>
                        <div className="HomePageGoogleWhyMainLeftBox">
                            <div className="HomePageGoogleWhyMainLeftImg">
                                <img src={require(`../../Images/check.png`)} />
                            </div>
                            <h3>Affordable Security Updates</h3>
                            <h4>Change lock configurations without replacement to prevent old keys from working, ensuring unauthorized access is eliminated affordably.</h4>
                        </div>
                        <div className="HomePageGoogleWhyMainLeftBox">
                            <div className="HomePageGoogleWhyMainLeftImg">
                                <img src={require(`../../Images/check.png`)} />
                            </div>
                            <h3>Protect Valuables</h3>
                            <h4>Secure important documents, cash, or belongings with professionally installed safes or access locked safes without damage.</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HomePageGoogleHowContact">
                <h4>HOW TO WORK WITH US</h4>
                <h3>Getting Your Locksmith Service Is Fast and Easy</h3>
                <div className="HomePageGoogleHowContactMain">
                    <img src={reslock} alt="Locksmith Service" />
                    <div className="HomePageGoogleHowContactMainRight">
                        <div className="HomePageGoogleHowContactMainRightBox">
                            <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/check.png`)} />
                            <div className="HomePageGoogleHowContactMainRightBoxRight">
                                <h1>Step 1</h1>
                                <h2>Call us at <a href={`tel:{CitiePhone}`}>{CitiePhone}</a> and explain your locksmith needs. Our team will provide you with an accurate quote over the phone.</h2>
                            </div>
                        </div>
                        <div className="HomePageGoogleHowContactMainRightBox">
                            <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/check.png`)} />
                            <div className="HomePageGoogleHowContactMainRightBoxRight">
                                <h1>Step 2</h1>
                                <h2>We’ll dispatch a professional locksmith to your location promptly, ready to resolve your issue.</h2>
                            </div>
                        </div>
                        <div className="HomePageGoogleHowContactMainRightBox">
                            <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/check.png`)} />
                            <div className="HomePageGoogleHowContactMainRightBoxRight">
                                <h1>Step 3</h1>
                                <h2>Relax as we complete your locksmith service efficiently and professionally, ensuring your satisfaction.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HomePageGoogleServices">
                <h3>Our Services</h3>
                <div className="HomePageGoogleServicesList">
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/2.jpg`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>Residential Locksmith</h1>
                            <h2>Our residential locksmith services are designed to enhance your home’s security and give you peace of mind. We provide lock rekeying to ensure old keys no longer work, new lock installations for added protection, and emergency lockout assistance to help you regain access quickly. Whether you’re upgrading your locks or facing an urgent situation, our skilled technicians are ready to assist with fast and reliable solutions tailored to your needs.</h2>

                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/10.jpg`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>Commercial Locksmith</h1>
                            <h2>Protect your business with our comprehensive commercial locksmith solutions. We offer advanced access control systems, high-security lock installations, and rekeying services to safeguard your workplace. Our team also specializes in emergency lockout assistance and lock repairs to keep your operations running smoothly. From small offices to large commercial properties, we provide customized security solutions to meet the unique needs of your business.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/carlockout.png`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>Automotive Locksmith</h1>
                            <h2>Our automotive locksmith services are here to save the day when you face car-related lock and key issues. Whether you’re locked out of your vehicle, need a replacement key, or have a broken ignition, we’ve got you covered. We use the latest tools and techniques to deliver efficient, damage-free solutions, ensuring you’re back on the road quickly. Trust us for prompt, professional assistance for all your automotive locksmith needs.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/carlock.png`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>Car Lockout</h1>
                            <h2>Getting locked out of your car is stressful, but we’re here to help. Our car lockout services are available 24/7 to provide quick, damage-free access to your vehicle. Using advanced tools and techniques, we ensure a hassle-free process. Whether it’s day or night, our experienced locksmiths are just a call away to get you back on the road with minimal disruption to your day.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/1.jpg`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>New Lock Installation</h1>
                            <h2>Enhance your property’s security with our professional new lock installation services. We install high-quality, durable locks for homes, businesses, and vehicles to keep your property safe. Whether you’re upgrading old locks or installing new ones for added protection, our technicians ensure a seamless and secure installation process. Count on us for expert recommendations and reliable solutions that fit your specific needs.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/12.jpeg`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>Lock Rekey</h1>
                            <h2>Rekeying your locks is an effective and affordable way to boost security without replacing the entire lock. Our professional lock rekeying services ensure old keys no longer work, giving you complete control over who has access. Ideal for new homeowners, landlords, or businesses, rekeying offers peace of mind at a fraction of the cost of new locks. Trust us for precision and expertise in every job.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <img src={require(`../../Images/safe.png`)} />
                        <div className="HomePageGoogleServicesBoxRigt">
                            <h1>Safe Lockout</h1>
                            <h2>Locked out of your safe? Our expert safe lockout services are here to help. Whether it’s a home safe, office safe, or high-security vault, we use specialized tools and techniques to access it without causing damage. Our skilled technicians understand the importance of safeguarding your valuables and ensure a secure, stress-free solution. No matter the make or model of your safe, we’re equipped to handle it efficiently.</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HomePageGooglecALL">
                <div className="HomePageGooglecALLLeft">
                    <h1>Our Locksmiths <br /> Are Ready to Help!</h1>
                    <h2>Call Now For A Free No Obligation Estimate</h2>
                </div>
                <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>

            </div>
        </div>
    )
}

